/**
 * Owner: Masa Bayu
 * File: marketplace-book-card.ts
 * Date:Time: 2026-09-28 11:47
 * Description: T2 QXBookCard — title · description · CTA hint · not purchase.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { assertOptionalTrimmed, assertValidId } from './guards';
/** Presentation CTAs only — never execute commerce or open Reader. */
export const QXREAD_BOOK_CARD_CTA = [
    'view_detail',
    'preview_available',
    'coming_soon',
    'unavailable',
];
function resolveCta(entry) {
    if (entry.availability === 'unavailable') {
        return 'unavailable';
    }
    if (entry.availability === 'coming_soon') {
        return 'coming_soon';
    }
    if (entry.preview?.enabled) {
        return 'preview_available';
    }
    return 'view_detail';
}
export function createQxreadBookCard(entry) {
    assertNoForbiddenFoundationKey(entry, 'QXRead book card');
    assertValidId(entry.publicationId, 'QXRead book card publicationId');
    const title = assertOptionalTrimmed(entry.title, 'QXRead book card title');
    if (title === null) {
        throw new Error('QXRead book card title is required');
    }
    const authorsRaw = entry.metadata.authors;
    const authors = Object.freeze(Array.isArray(authorsRaw)
        ? authorsRaw.filter((author) => typeof author === 'string')
        : []);
    const tagsRaw = entry.metadata.tags;
    const tags = Object.freeze(Array.isArray(tagsRaw) ? tagsRaw.filter((tag) => typeof tag === 'string') : []);
    const coverRaw = entry.metadata.coverAssetRef;
    const coverAssetRef = typeof coverRaw === 'string' ? coverRaw : null;
    const descriptionRaw = entry.metadata.description;
    const description = typeof descriptionRaw === 'string' && descriptionRaw.trim().length > 0
        ? descriptionRaw.trim()
        : null;
    return Object.freeze({
        publicationId: entry.publicationId,
        title,
        description,
        authors,
        coverAssetRef,
        listedVersion: entry.listedVersion,
        availability: entry.availability,
        tags,
        cta: resolveCta(entry),
        marketplaceReady: entry.marketplaceReady,
    });
}
/** Book card never grants entitlement or launches Reader. */
export function isBookCardCommerceSafe(card) {
    return QXREAD_BOOK_CARD_CTA.includes(card.cta);
}
//# sourceMappingURL=marketplace-book-card.js.map